// extracted by mini-css-extract-plugin
export const flexStyles = "footerStyles-module--flexStyles--1IQD8";
export const lastBlock = "footerStyles-module--lastBlock--2h0cU";
export const siteFooter = "footerStyles-module--site-footer--29BUT";
export const footerIcon = "footerStyles-module--footerIcon--1biMX";